import { CourseLectureAssignmentStatusEnum } from 'modules/course/types/course-menu-interface'

export const getAssignmentStatusTextColor = (
  status?: CourseLectureAssignmentStatusEnum,
):
  | 'text-text-success'
  | 'text-text-error'
  | 'text-THEME-primary'
  | 'text-text-tertiary'
  | undefined => {
  switch (status) {
    case CourseLectureAssignmentStatusEnum.Approved: {
      return 'text-text-success'
    }
    case CourseLectureAssignmentStatusEnum.Rejected: {
      return 'text-text-error'
    }
    case CourseLectureAssignmentStatusEnum.Pending: {
      return 'text-THEME-primary'
    }
    case CourseLectureAssignmentStatusEnum.NotSubmitted: {
      return 'text-text-tertiary'
    }
    default: {
      break
    }
  }

  return undefined
}
